/**
 * Modelo para el registro de horas de los empleados
 */
export interface RegistroHoras {
    id: number;
    employeesId: number;
    inicio: Date;
    fin: Date;
    estado: number;
    finalizadoAutomatico: boolean;
    cadenaInicio: string;
    cadenaFin: string;
    latitudInicio?: number;
    longitudInicio?: number;
    latitudFin?: number;
    longitudFin?: number;
}

/**
 * Modelo para el filtro de registros de horas
 */
export interface RegistroHorasFilter {
    employeesId?: number;
    fechaInicio?: Date;
    fechaFin?: Date;
    estado?: number;
    finalizadoAutomatico?: boolean;
    pageNumber?: number;
    pageSize?: number;
}

/**
 * Modelo para el registro de pausas
 */
export interface RegistroPausa {
    id: number;
    registroHorasId: number;
    inicio: Date;
    fin: Date;
    motivo: string;
    cadenaInicio: string;
    cadenaFin: string;
}

/**
 * Modelo para el filtro de pausas
 */
export interface RegistroPausaFilter {
    employeesId?: number;
    registroHorasId?: number;
    fechaInicio?: Date;
    fechaFin?: Date;
    pageNumber?: number;
    pageSize?: number;
}

/**
 * Modelo para la solicitud de pausa
 */
export interface PausaRequest {
    motivo: string;
}

/**
 * Modelo para el rango de fechas del registro
 */
export interface RangoFechasRegistro {
    inicio: string;
    fin: string;
}

export enum EstadoRegistro {
    Iniciado = 1,
    Validado = 2,
    Rechazado = 3,
    Modificado = 4,
    Incompleto = 5,
    Cancelado = 6,
    InicioPausa = 7,
    Pendiente = 8,
}

export enum TipoRegistro {
    Entrada = 1,
    Salida = 2,
    InicioPausa = 3,
    FinPausa = 4,
    Incidencia = 5,
    Teletrabajo = 6,
}

export interface RegistroHoras {
    registroHorasId: number;
    employeesId: number;
    fecha: string;
    horaEntrada: string | null;
    horaSalida: string | null;
    finalizadoAutomatico: boolean;
    desplazamientoHorario: number;
    tipoRegistro: TipoRegistro;
    comentario: string;
    ubicacion: string;
    estado: number;
    validadoPor: number;
}

export interface RangoFechasRegistro_DTO {
    inicio: string;
    fin: string;
}

export interface RegistroDetalleTiempo extends RegistroHoras {
    cadenaEstado: string;
    duracion: string;
    pausas: RegistroPausa[];
    latitudInicio?: number;
    longitudInicio?: number;
    latitudFin?: number;
    longitudFin?: number;
}

export interface ValidarRegistrosPorFechasDTO {
    employeesId: number;
    userId: number;
    fechaInicio: string;
    fechaFin: string;
}

export enum TipoCambioHistorial {
    Modificacion = 1,
    Rechazo = 2,
    Validacion = 3,
    Cancelacion = 4,
}

/**
 * Entrada del histórico de auditoría de un registro de horas (append-only en el backend).
 */
export interface RegistroHorasHistorial {
    id: number;
    registroHorasId: number;
    fechaCambio: string;
    usuarioId: number;
    tipoCambio: TipoCambioHistorial;
    motivo: string;
    valoresAnteriores: string;
}

/**
 * Datos para editar un registro de horas ya creado. El motivo es obligatorio.
 */
export interface EditarRegistroHorasDTO {
    horaEntrada?: string | null;
    horaSalida?: string | null;
    comentario?: string;
    motivo: string;
}

export interface RechazarRegistroDTO {
    motivo: string;
}

export interface RechazarRegistrosPorFechasDTO {
    employeesId: number;
    userId: number;
    fechaInicio: string;
    fechaFin: string;
    motivo: string;
}
